import styles from "./NewManager.module.css";
import { useAuth } from "../../context/Auth";
import InputTag from "../FormComponents/InputTag";
import { useEffect, useState } from "react";
import { useToast } from "../Toaster/Toaster";
import { useNavigate } from "react-router-dom";
import fetchData from "../../../APIsControll/apiControll";
import ModalWrapper from "../layoutWrapper/ModalWrapper";
import ManagerModal from "./ManagerModal";
import SingleManagerDevicesTable from "../Manager/SingleManagerDevicesTable";

const RenderWebSection = ({
  managerData,
  setManagerData,
  isEdit,
  deviceList,
  setDeviceTableKey,
  deviceTableKey,
  havePassword,
  errors,
}) => {
  const { mode, managerId } = useAuth();
  const { show } = useToast();

  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const navi = useNavigate();

  useEffect(() => {
    setIsModalOpen(false);
  }, [deviceTableKey]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const openTable = () => {
    handleOpenModal(
      <SingleManagerDevicesTable
        key={deviceTableKey}
        data={deviceList}
        onRefresh={refreshDeviceTable}
        loginId={managerData.loginId}
      />
    );
  };

  const openManagerModal = () => {
    handleOpenModal(
      <ManagerModal
        heading={"Remove Password"}
        centerHeading={"Are you sure you want to Remove Password?"}
        subHeading={"To confirm! type remove in the text field."}
        targetWord={"remove"}
        handleSubmit={RemoveUser}
        handleCloseModal={() => setIsModalOpen(false)}
        focus={true}
      />
    );
  };

  const refreshDeviceTable = () => {
    setDeviceTableKey((prev) => prev + 1);
  };

  const RemoveUser = async () => {
    try {
      const paylod = {
        managerId: managerId,
        loginId: managerData.loginId,
      };
      const res = await fetchData("managers/removePassword", paylod);
      if (res?.status === "success") {
        show(`${res?.msg}`, "success");
        navi("/managers");
      }
      if (res?.status === "failed") {
        show(`${res?.msg}`, "error");
      }
    } catch (error) {
      show(`something went wrong`, "error");
    }
  };


  return (
    <div className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}>
      <p
        className={styles.wa_heading}
        style={{
          color: mode ? "#ffffff" : "#000000",
        }}
      >
        Device Permissions
      </p>
      <div className={styles.wa_form}>
        <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
          {modalContent}
        </ModalWrapper>
      </div>

      <div className={styles.element}>
        <InputTag
          name="loginId"
          value={managerData.loginId}
          labelText={"Login ID / Username"}
          placeholderText={"Enter a Login ID / Username"}
          placeholderType={"text"}
          required={true}
          disabled={isEdit}
          star
          maxLength={36}
          onChange={(e) =>
            setManagerData((prev) => ({
              ...prev,
              loginId: e.target.value,
            }))
          }
          autoComplete={"new-password"}
          padding={"8px"}
          fontSize={"12px"}
        />
        {isEdit && (
          <text
            className={styles.wa_device_list_text}
            onClick={() => openTable()}
          >
            Device List
          </text>
        )}

        {errors.loginId && (
          <span className={styles.error}>{errors.loginId}</span>
        )}
      </div>
      <div className={`${styles.Have_pasword} ${styles.element}`}>
        <InputTag
          name="password"
          value={managerData.password}
          labelText={"Password"}
          placeholderText={"Create a Password"}
          placeholderType={"password"}
          required={true}
          star
          maxLength={30}
          onChange={(e) =>
            setManagerData((prev) => ({
              ...prev,
              password: e.target.value,
            }))
          }
          autoComplete={"new-password"}
          padding={"8px"}
          fontSize={"12px"}
        />

        {havePassword && (
          <span id={styles.RemovePass} onClick={() => openManagerModal()}>
            Remove Password
          </span>
        )}

        {errors.password && (
          <span className={styles.error}>{errors.password}</span>
        )}
      </div>

      <div className={styles.element}>
        <InputTag
          name="confirmPassword"
          value={managerData.confirmPassword}
          labelText={"Confirm Password"}
          placeholderText={"Re-Enter Password"}
          placeholderType={"password"}
          required={true}
          star
          maxLength={30}
          onChange={(e) =>
            setManagerData((prev) => ({
              ...prev,
              confirmPassword: e.target.value,
            }))
          }
          autoComplete={"new-password"}
          padding={"8px"}
          fontSize={"12px"}
        />
        {errors.confirmPassword && (
          <span className={styles.error}>{errors.confirmPassword}</span>
        )}
      </div>
    </div>
  );
};

export default RenderWebSection;
